import Table from 'react-bootstrap/Table';


function TableLingvoAnylize( { data } ) {

  return (
    <>
      <h2>Результат лингво-анализа:</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Наименование</th>
            <th>Содержимое</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Токены</td>
            <td style={{ textAlign: 'left' }}>{ data.tokens.join(' | ') }</td>
          </tr>
          <tr>
            <td>Леммы</td>
            <td style={{ textAlign: 'left' }}>{ data.lemmas.join(' | ') }</td>
          </tr>
          <tr>
            <td>Стоп слова</td>
            <td style={{ textAlign: 'left' }}>{ data.stopwords.join(' | ') }</td>
          </tr>
          <tr>
            <td>Уникальные леммы</td>
            <td style={{ textAlign: 'left' }}>{ data.unique_lemmas.join(' | ') }</td>
          </tr>
        </tbody>
      </Table>
    </>

  );
}


export default TableLingvoAnylize;
